module.exports = __webpack_public_path__ + "img/brgj.f5578200.png";